export function getURLSearchParams(query = null) {
    const _search = new URLSearchParams(window.location.search);
    //
    if (query === null) {
        return _search;
    }
    //
    return _search.get(query);
}